import { useQuery } from '@apollo/client';
import {
  MostDeviceListFilterInput,
  MostDevicesDocument,
  MostDevicesQuery,
} from 'src/graphql/generated/graphql';

export const useMostDevices = (filter?: MostDeviceListFilterInput) => {
  const { data, loading } = useQuery<MostDevicesQuery>(MostDevicesDocument, {
    variables: {
      filter,
    },
    skip: !filter?.storeIds?.length && !filter?.storeIds?.length,
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-only',
  });

  return {
    data: data?.mostDevices,
    loading,
  };
};
